import {
  ApiTimeOffAccrualFrequencyTypes,
  ApiTimeOffPolicyAccrualAtType,
  getAccrualFreqKeyMap,
} from "@/types/time-off/time-off-policy.types.ts";
import { Box, Text } from "@skailer-com/uikit";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

function getAccrualAtTypeKeyMap(): Record<ApiTimeOffPolicyAccrualAtType, string> {
  return {
    [ApiTimeOffPolicyAccrualAtType.start_of_accrual_period]: i18n.t(
      "time_off:accrual_at_type_at_start_each"
    ),
    [ApiTimeOffPolicyAccrualAtType.end_of_accrual_period]: i18n.t(
      "time_off:accrual_at_type_at_end_each"
    ),
  };
}

interface TimeOffPolicyAccrualSummaryProps {
  isHours: boolean;
  accrualAmount: number;
  accrualFrequencyType: ApiTimeOffAccrualFrequencyTypes;
  accrualAtType: ApiTimeOffPolicyAccrualAtType;
}

export function TimeOffPolicyAccrualSummary({
  isHours,
  accrualAmount,
  accrualFrequencyType,
  accrualAtType,
}: TimeOffPolicyAccrualSummaryProps) {
  const { t } = useTranslation();
  const accrualFreqKeyMap = getAccrualFreqKeyMap();
  const accrualAtTypeKeyMap = getAccrualAtTypeKeyMap();

  return (
    <Box>
      <Text className={"text-secondary"}>{t("time_off:accrual_summary_earn_caption") + " "}</Text>
      <Text className={"font-semibold"}>{accrualAmount + " "}</Text>
      <Text className={"text-secondary"}>
        {(isHours
          ? t("time_off:accrual_summary_plural_leave_hours", { count: accrualAmount })
          : t("time_off:accrual_summary_plural_leave_days", { count: accrualAmount })) + " "}
      </Text>
      <Text className={"font-semibold"}>{accrualFreqKeyMap[accrualFrequencyType] + ", "}</Text>
      <Text className={"text-secondary"}>
        {t("time_off:accrual_summary_added_at_caption", { amount: accrualAmount }) + " "}
      </Text>
      <Text className={"font-semibold"}>{accrualAtTypeKeyMap[accrualAtType]}</Text>
      {"."}
    </Box>
  );
}
